<template>
	<div id="usre-baseinfor" class="oh" > 
		<leftnav class="fl" mkcode="E" itemcode="E-DBQY"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''" >
			<govheader :show-video="true" :video-type="5"></govheader>
			<div class="index_left_centerpage"> 
			<div class="whitebox right_topbox" style="min-height: 800px;">
				<div class="right_boxtitle">
					<span class="fl right_title">对比记录</span>  
				</div>
					<div class="compare-record-list">
							<div class="titlebox">
								<h5 class="title fl flbox">对比企业</h5> <h5 class="fl flbox1 title tac">操作</h5>
							</div>
							<div class="oh" :key="i" v-for="(list,i) in recordList">
								<div class="fl flbox">
								<!-- 	<span class="fl" v-for="item in list.sourceEnterprise" :data-d="item.id" @click="routerlinkid('/enterprises',item.stockCode)">{{item.title}}</span> -->
								{{list.title}}
								</div> 
								<div class="fl flbox1 tac">
									<span class="curp mr-3" @click="routerlinkid('/enterprise-compare',list.id)">查看结果</span>
									<span class="grayfont hovercolor cur-pointer" @click="deleteRecord(list.id)">删除记录</span>
									</div>
							</div>
					</div>
			</div>
			</div>
		</div>
	</div>
</template> 
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
	export default {
	  name: 'enterpriseCompareRecords',
	  computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
	  data(){return{
				userdata:{}, 
				title:'对比记录', 
			recordList:[],
			}},
		 created() {
		 	this.userdata=this.getuseriformation(); 
		 },
			mounted() { 
			this.bus.$emit('loading', true);
				this.getlist();
			},
			methods:{  
				getlist(){
					var that=this;
					this.$axios.get(this.$api.cyl.enterpriseComparison.list({page:1}), {headers: {AuthToken: this.userdata.token}
					}).then(function(res) {
						if(res.data.success){
						console.log('对比记录列表', res.data.list); 
						that.recordList=res.data.list;
							that.bus.$emit('loading', false);
						} else {
							
						}
					}).catch(function(error) {console.log(error)});
				},
				deleteRecord(id){
					var that=this;
					let querydata={id:id};
					$.ajax({
						type:"POST",
						url:this.$api.cyl.enterpriseComparison.delete(),
						data:querydata,
						headers:{AuthToken:this.userdata.token },
						success:function(res){  
							if(res.success){
								that.recordList=that.recordList.filter(list=>{
									return list.id!=id;
								})
							}
							that.$message({type:res.success?'success':'error',message:res.success?'删除成功':res.msg}) 
						} 
					});
				},
				
				
			}
	}  
</script>

<style>
	 
	.compare-record-list .titlebox{
		border-bottom: 1px solid #eee;overflow: hidden;
	}
	.compare-record-list .title{
		height:100px;line-height: 100px;font-size: 18px;font-weight: bold;
	}
	.compare-record-list .flbox{
		width: 70%;
	}
	.compare-record-list .flbox1{
		width: 30%;
	}
	.compare-record-list>div.oh{
			width: 100%;padding:30px 0 20px;border-bottom: 1px solid #eee;
	}
	.compare-record-list span.fl{
		margin-right:10px;margin-bottom:10px;
	}
	 
</style>
